import { useEffect, useState } from 'react'
import { useLiczbaOczekujacych } from '../dane/kolejka.js'
import './pasek-polaczenia.css'

function odmiana(ile: number): string {
  if (ile === 1) return 'zmiana czeka'
  const reszta = ile % 10
  const setki = ile % 100
  const mnoga = reszta >= 2 && reszta <= 4 && (setki < 12 || setki > 14)
  return mnoga ? 'zmiany czekają' : 'zmian czeka'
}

/**
 * Bez sieci aplikacja działa dalej na danych lokalnych, a zapisy czekają
 * w kolejce. Użytkownik musi wiedzieć jedno i drugie: że nie widzi zmian
 * z innych urządzeń i że jego własne jeszcze nie doszły.
 */
export function PasekPolaczenia() {
  const [online, ustawOnline] = useState(() => navigator.onLine)
  const oczekujace = useLiczbaOczekujacych()

  useEffect(() => {
    const dostepna = () => ustawOnline(true)
    const brak = () => ustawOnline(false)
    window.addEventListener('online', dostepna)
    window.addEventListener('offline', brak)
    return () => {
      window.removeEventListener('online', dostepna)
      window.removeEventListener('offline', brak)
    }
  }, [])

  if (online && oczekujace === 0) return null

  const tresc = online
    ? `${oczekujace} ${odmiana(oczekujace)} na wysłanie`
    : oczekujace === 0
      ? 'Brak połączenia — widzisz ostatnio pobrane dane'
      : `Brak połączenia — ${oczekujace} ${odmiana(oczekujace)} na wysłanie`

  return (
    <p
      className={online ? 'pasek-polaczenia pasek-polaczenia--kolejka' : 'pasek-polaczenia'}
      role="status"
    >
      {tresc}
    </p>
  )
}
